<script setup lang="ts">
const route = useRoute();
const { data: player } = useFetch("/api/list", {
  query: {
    id: route.params.id,
  },
});
</script>

<template>
  <div class="section">
    <h1>
      Event:
      <NuxtLink :to="'/event/' + player?.event_id">{{
        player?.event_name
      }}</NuxtLink>
    </h1>
    <h2>{{ player?.player_name }}</h2>
    <ListView :player />
  </div>
</template>
